import React, { useState, useEffect, useContext, useRef } from 'react'
import { Button } from '@mui/material'
import openSocket from 'socket.io-client'
import './Message.css'
import ActiveSellers from './ActiveSellers'
//import SearchNav from '../../components/molecules/SearchNav'
import ActiveSubjects from './ActiveSubjects'
import Conversations from './Conversations'
//import CommonContext from '../../context/common/commonContext'
//import { apiCall } from '../../common/api'
import Drawer from '@mui/material/Drawer'
import Layout from '../../product/components/templates/Layout'
import MessageContext from '@/product/context/message/messageContext'
import { response } from '@/product/context/common'
import AuthContext from '@/product/context/auth/authContext'
import { LocalLaundryService } from '@mui/icons-material'

const Message = () => {
    // let { getLangPhrase, language, phrase, getMsgUnreadCount } = useContext(CommonContext)

    const messageContext = useContext(MessageContext)
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated, loadUser } = authContext

    const {
        searchactualmessages,
        getAllMessages,
        searchprojectmessages,
        all_messages,
        all_actual_messages,
        all_project_messages,
        deleteMessage,
        searcharchiveMessages,
        saveMessage,
        responseStatus: responseStatusMessage,
    } = messageContext
    const [parentMessageData, setParentMessageData] = useState({})
    const [sellerMessages, setSellerMessages] = useState({})
    const [conversations, setConversations] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [showSubjects, setShowSubjects] = useState(false)
    const userRef = useRef(0)
    const authUserRef = useRef(user)
    const conversationsRef = useRef(conversations)
    const [selectedSeller, setSelectedSeller] = useState(0)
    const [isArchive, setIsArchive] = useState(false)

    const selectedSellerRef = useRef(selectedSeller)
    const isArchiveRef = useRef(isArchive)

    useEffect(() => {
        selectedSellerRef.current = selectedSeller
    }, [selectedSeller])

    useEffect(() => {
        isArchiveRef.current = isArchive
    }, [isArchive])

    authUserRef.current = user
    conversationsRef.current = conversations
    const [state, setState] = useState({
        left: false,
    })
    const [activeSeller, setActiveSeller] = useState({
        index: '',
        element: '',
    })
    const [activeProject, setActiveProject] = useState({
        index: '',
        element: '',
    })

    const [selectedProject, setSelectedProject] = useState(0)
    const [activeTab, setActiveTab] = useState()
    const [firstTab, setFirstTab] = useState()

    // useEffect(() => {
    //     getLangPhrase(language)
    //     document.title = global.site_title + ' | Messages'
    // }, [language])

    useEffect(() => {
        loadUser()
    }, [])

    useEffect(() => {
        if (isAuthenticated) {
            setIsLoading(true)
            setSellerMessages({})
            setConversations({})
            setSelectedSeller(0)
            setSelectedProject(0)
            getParentMessageData()
        }
    }, [isArchive, isAuthenticated])

    useEffect(() => {
        if (firstTab) {
            setActiveTab(firstTab)
        }
    }, [firstTab])

    const getParentMessageData = () => {
        let parentMessageFromData = {
            archive: isArchiveRef.current,
        }
        getAllMessages(parentMessageFromData)
    }

    useEffect(() => {
        if (all_messages) {
            setParentMessageData(all_messages)
            setIsLoading(false)
        }
    }, [all_messages])

    useEffect(() => {
        if (selectedSeller !== 0) {
            if (all_project_messages) {
                setSellerMessages(all_project_messages)
            }
        } else {
            setSellerMessages({})
        }
    }, [all_project_messages, selectedSeller])

    const getProjectMessageData = async (seller_id, project_id) => {
        if (seller_id) {
            let getProject = {
                seller_id: seller_id,
                archive: isArchiveRef.current,
            }
            setSelectedSeller(seller_id)
            searchprojectmessages(getProject)

            let pid = project_id || 0
            let getMessage = {
                project_id: pid,
                seller_id: seller_id,
                archive: isArchiveRef.current,
            }
            searchactualmessages(getMessage)
        }
    }

    const getConverstionData = async (
        seller_id,
        project_id,
        unreadMessageCount
    ) => {
        if (project_id || project_id == 0) {
            let getMessage = {
                project_id: project_id,
                seller_id: seller_id ? seller_id : selectedSellerRef.current,
                archive: isArchiveRef.current,
            }

            if (unreadMessageCount != '') {
                getMessage.activemainusertunread = unreadMessageCount
                getMessage.activesellerunread = unreadMessageCount
            }
            setSelectedProject(project_id)
            searchactualmessages(getMessage)
        }
    }

    useEffect(() => {
        if (responseStatusMessage) {
            if (
                responseStatusMessage.status === 'success' &&
                responseStatusMessage.from === 'deleteMessages'
            ) {
                // reset(seller_id, project_id, '')
            } else if (
                responseStatusMessage.status === 'success' &&
                responseStatusMessage.from === 'saveMessage'
            ) {
                // reset(seller_id, project_id, '')
            } else if (
                responseStatusMessage.status === 'success' &&
                responseStatusMessage.from === 'archive_messages'
            ) {
                getParentMessageData()
                getProjectMessageData(selectedSellerRef.current)
            }
        }
    }, [responseStatusMessage])

    useEffect(() => {
        if (selectedSeller !== 0) {
            if (all_actual_messages) {
                setConversations(all_actual_messages)
            }
        } else {
            setConversations({})
        }
    }, [all_actual_messages, selectedSeller])

    const sellerClickHandler = async (e, index, seller_id, project_id) => {
        e.persist()
        let result = getProjectMessageData(seller_id, project_id)
        if (result) {
            setSelectedSeller(seller_id)
        }

        setSelectedProject(project_id || 0)
        // setConversations({ actualmessages: [] })
    }

    const projectClickHandler = async (
        e,
        index,
        seller_id,
        unreadMessageCount,
        project_id
    ) => {
        e.persist()
        let result = getConverstionData(
            seller_id,
            project_id,
            unreadMessageCount
        )
        if (result) {
            setSelectedProject(project_id)
        }
        userRef.current = project_id
    }

    const handleMessageSubmit = async (values) => {
        let messageFormData = {
            ...values,
            attachinsidename: '',
            attachorginalname: '',
            sellermsgpost: selectedSeller,
            projectmsgpost: selectedProject,
            status: 'open',
            fromadmin: 1,
        }

        saveMessage(messageFormData)
    }

    const handleMessageDelete = async (message_id, seller_id, project_id) => {
        let deleteMessageFormData = {
            id: message_id,
        }
        deleteMessage(deleteMessageFormData)

        // const res = await apiCall('post', '', deleteMessageFormData, '', 'messages/deletemessage')
        // if (res.data.success) {
        //     reset(seller_id, project_id, '')
        // }
    }

    const assignActiveTab = (element) => {
        setFirstTab(element)
    }

    const toggleTab = (e, archiveState) => {
        setIsArchive(archiveState)
        if (activeTab) {
            activeTab.classList.remove('active')
        }
        e.currentTarget.classList.add('active')
        setActiveTab(e.currentTarget)
    }

    const handleActiveTabClick = (e) => {
        toggleTab(e, false)
    }

    const handleArchiveTabClick = (e) => {
        toggleTab(e, true)
    }

    const handleUnarchiveButtonClick = async (seller_id, project_id) => {
        let unarchiveFormData = {
            seller_id: seller_id,
            project_id: project_id,
            archive: true,
        }
        searcharchiveMessages(unarchiveFormData)

        // const res = await apiCall('post', '', unarchiveFormData, '', 'messages/archivemessages')
        // if (res.data.success) {
        //     firstTab.click()
        // }
    }

    const handleArchiveButtonClick = async (seller_id, project_id) => {
        let archiveFormData = {
            seller_id,
            project_id: project_id,
        }
        // if (sellerMessages.projectmessages[activeProject.index].from_admin) {
        //     archiveFormData.seller_id =
        //         sellerMessages.projectmessages[activeProject.index].from_id
        // } else {
        //     archiveFormData.seller_id =
        //         sellerMessages.projectmessages[activeProject.index].to_id
        // }

        searcharchiveMessages(archiveFormData)

        // const res = await apiCall('post', '', archiveFormData, '', 'messages/archivemessages')
        // if (res.data.success) {
        //     if (project_id == sellerMessages.projectmessages[activeProject.index].project_id) {
        //         reset(seller_id, project_id, '')
        //     } else {
        //         reset(seller_id, '', '')
        //     }
        // }
    }

    const socketUpdate = (data) => {
        if (authUserRef.current) {
            if (
                data &&
                authUserRef.current &&
                data.users.includes(authUserRef.current.admin_id)
            ) {
                let seller_id = data.users.filter(
                    (e) => e != authUserRef.current.admin_id
                )[0]

                // Refresh the list of sellers (moves new message user to top)
                getParentMessageData()

                // If the incoming message is from the currently selected seller, refresh conversation or append
                if (selectedSellerRef.current == seller_id) {
                    getProjectMessageData(seller_id, userRef.current)
                }
            }
        }
    }

    useEffect(() => {
        const socket = openSocket(`${process.env.REACT_APP_DOMAIN}/`, {
            transports: ['websocket'],
        })
        socket.on('chatupdate', (data) => {
            data.type = 'update'
            socketUpdate(data)
        })
        socket.on('chatdelete', (data) => {
            data.type = 'delete'
            socketUpdate(data)
        })
        return () => {
            socket.disconnect()
        }
    }, [])

    const reset = (seller_id, project_id, unreadMessageCount) => {
        if (user) {
            getParentMessageData()
        }
        getProjectMessageData(seller_id)
        if (project_id != '') {
            getConverstionData(seller_id, project_id, '')
        }
        // if (unreadMessageCount > 0) {
        //     getMsgUnreadCount()
        // }
    }

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === 'keydown' &&
            (event.key === 'Tab' || event.key === 'Shift')
        ) {
            return
        }

        setState({ ...state, [anchor]: open })
    }

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    {/* <SearchNav handleKeyDown={() => {}} /> */}
                    <div className="messages">
                        <div className="customContainer">
                            <div className="messageTop d-flex justify-content-between align-items-center">
                                <h2>All Messages</h2>
                                <div className="d-flex justify-content-end">
                                    <Button
                                        className="active"
                                        onClick={handleActiveTabClick}
                                        ref={(element) =>
                                            assignActiveTab(element)
                                        }
                                    >
                                        {'Active' +
                                            '(' +
                                            parentMessageData.activemsgcount +
                                            ')'}
                                    </Button>
                                    <Button onClick={handleArchiveTabClick}>
                                        {'Archive' +
                                            '(' +
                                            parentMessageData.archivemsgcount +
                                            ')'}
                                    </Button>
                                </div>
                            </div>
                            <div className="messageCnt">
                                {isArchive ? (
                                    parentMessageData.archivemsgcount > 0 ? (
                                        <>
                                            <div className="messageHead d-flex justify-content-between align-items-center flex-wrap">
                                                <Button
                                                    className="toggleSellers"
                                                    onClick={toggleDrawer(
                                                        'left',
                                                        true
                                                    )}
                                                >
                                                    <span className="material-icons">
                                                        people
                                                    </span>{' '}
                                                    Show Users
                                                </Button>
                                                <h4>Users</h4>
                                                <h5>
                                                    Conversations
                                                    {/* <span>
                                                        {sellerMessages.projectmessages &&
                                                        activeProject.index !==
                                                            ''
                                                            ? sellerMessages
                                                                  .projectmessages[
                                                                  activeProject
                                                                      .index
                                                              ]?.title
                                                            : ''}
                                                    </span> */}
                                                </h5>

                                                {/* <h6>
                                                    {sellerMessages.projectmessages &&
                                                    activeProject.index !== ''
                                                        ? sellerMessages
                                                              .projectmessages[
                                                              activeProject
                                                                  .index
                                                          ]?.conversationcount +
                                                          ' ' +
                                                          'Conversations'
                                                        : 'Conversations'}
                                                </h6> */}
                                            </div>
                                            <div className="messageBody d-flex justify-content-start">
                                                <ActiveSellers
                                                    sellers={
                                                        parentMessageData.messagesforusers
                                                    }
                                                    onClick={sellerClickHandler}
                                                    isArchive={isArchive}
                                                    selectedSeller={
                                                        selectedSeller
                                                    }
                                                />
                                                <ActiveSubjects
                                                    sellerMessages={
                                                        sellerMessages
                                                    }
                                                    onClick={
                                                        projectClickHandler
                                                    }
                                                    isArchive={isArchive}
                                                    handleUnarchiveButtonClick={
                                                        handleUnarchiveButtonClick
                                                    }
                                                    handleArchiveButtonClick={
                                                        handleArchiveButtonClick
                                                    }
                                                />
                                                <Conversations
                                                    conversations={
                                                        conversations
                                                    }
                                                    handleMessageSubmit={
                                                        handleMessageSubmit
                                                    }
                                                    handleMessageDelete={
                                                        handleMessageDelete
                                                    }
                                                />
                                            </div>
                                        </>
                                    ) : isLoading ? (
                                        <div className="nomessage">
                                            Loading...
                                        </div>
                                    ) : (
                                        <div className="nomessage">
                                            No New Messages
                                        </div>
                                    )
                                ) : parentMessageData.activemsgcount > 0 ||
                                  true ? (
                                    <>
                                        <div className="messageHead d-flex justify-content-between align-items-center flex-wrap">
                                            <Button
                                                className="toggleSellers"
                                                onClick={toggleDrawer(
                                                    'left',
                                                    true
                                                )}
                                            >
                                                <span className="material-icons">
                                                    people_alt
                                                </span>{' '}
                                                Show Users
                                            </Button>
                                            <h4>Users</h4>
                                            <h5>
                                                Conversations
                                                {/* {console.log(
                                                    'activeProject.index',
                                                    activeProject.index,
                                                    sellerMessages.projectmessages
                                                )}
                                                <span>
                                                    {sellerMessages.projectmessages &&
                                                    sellerMessages
                                                        .projectmessages
                                                        .length &&
                                                    activeProject.index !==
                                                        '' &&
                                                    sellerMessages
                                                        .projectmessages[
                                                        activeProject.index
                                                    ]
                                                        ? sellerMessages
                                                              .projectmessages[
                                                              activeProject
                                                                  .index
                                                          ].title
                                                        : ''}
                                                </span> */}
                                            </h5>
                                            {/* <h6>
                                                {sellerMessages.projectmessages &&
                                                sellerMessages.projectmessages
                                                    .length &&
                                                activeProject.index !== '' &&
                                                sellerMessages.projectmessages[
                                                    activeProject.index
                                                ]
                                                    ? sellerMessages
                                                          .projectmessages[
                                                          activeProject.index
                                                      ].conversationcount +
                                                      ' ' +
                                                      'Conversations'
                                                    : 'Conversations'}
                                            </h6> */}
                                        </div>
                                        <div className="messageBody d-flex justify-content-start">
                                            <ActiveSellers
                                                sellers={
                                                    parentMessageData.messagesforusers
                                                }
                                                onClick={sellerClickHandler}
                                                isArchive={isArchive}
                                            />
                                            <ActiveSubjects
                                                sellerMessages={sellerMessages}
                                                onClick={projectClickHandler}
                                                isArchive={isArchive}
                                                selectedProject={
                                                    selectedProject
                                                }
                                                handleUnarchiveButtonClick={
                                                    handleUnarchiveButtonClick
                                                }
                                                handleArchiveButtonClick={
                                                    handleArchiveButtonClick
                                                }
                                            />
                                            <Conversations
                                                conversations={conversations}
                                                handleMessageSubmit={
                                                    handleMessageSubmit
                                                }
                                                handleMessageDelete={
                                                    handleMessageDelete
                                                }
                                            />
                                        </div>
                                    </>
                                ) : isLoading ? (
                                    <div className="nomessage">Loading...</div>
                                ) : (
                                    <div className="nomessage">
                                        No New Messages
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <Drawer
                        anchor="left"
                        open={state['left']}
                        className="msgDrawer"
                        onClose={toggleDrawer('left', false)}
                    >
                        <h4 className="msgHead">
                            {showSubjects === true
                                ? 'Active Conversations'
                                : 'Active Sellers'}
                        </h4>
                        {showSubjects === true ? (
                            <span>
                                <Button
                                    className="backSellerBtn"
                                    onClick={() => setShowSubjects(false)}
                                >
                                    <span className="material-icons">
                                        arrow_back
                                    </span>
                                    Back to Users
                                </Button>
                                <ActiveSubjects
                                    sellerMessages={sellerMessages}
                                    onClick={projectClickHandler}
                                    isArchive={isArchive}
                                    handleUnarchiveButtonClick={
                                        handleUnarchiveButtonClick
                                    }
                                    handleArchiveButtonClick={
                                        handleArchiveButtonClick
                                    }
                                />
                            </span>
                        ) : (
                            <span onClick={() => setShowSubjects(true)}>
                                <ActiveSellers
                                    sellers={parentMessageData.messagesforusers}
                                    onClick={sellerClickHandler}
                                    isArchive={isArchive}
                                    selectedSeller={selectedSeller}
                                />
                            </span>
                        )}
                    </Drawer>
                </div>
            </Layout>
        </>
    )
}

export default Message
